import React from "react";
import { Link } from 'react-router-dom';

/*const _data = ['All', 'Kid Toys', 'Inflatables', 'Kiddy Pools', 'Home Decor', 'Closet Organiser', 'Strollers & Carriers', 'Yoga & Gym Apparel'];*/

export default ({ data, left, visible, hidden, popup_ref }) => {

  const display = `${!visible ? 'none' : 'block'}`;

  return (
    <div ref={popup_ref} className={`Product-Categories ${hidden}`} style={{ left: left, display: display }}>
      <div className="Category-Wrapper">
        {
          data.map((a,i) => <Link key={i} className='Category' to={`/products/${a.title}`}>
            {`${a.title.toLowerCase()}`}
          </Link>)
        }
      </div>
    </div>
  )

};
